import { BrowserRouter } from 'react-router-dom';
import { BlockEditor, Progress } from '@components';
import { useEditMode } from '@hooks';
import { Box } from '@mui/material';

export const EditMode = () => {
  const { ready, inEditMode, inBlockEdit, inCompareRightPane } = useEditMode();

  const isBlockEditorReady = ready && inEditMode && inBlockEdit;
  const isBlockPreviewReady = inCompareRightPane && inBlockEdit;
  const showContent = isBlockEditorReady || isBlockPreviewReady;

  if (!inBlockEdit) {
    return null;
  }

  return showContent ? (
    <Box>
      <BrowserRouter>
        <BlockEditor />
      </BrowserRouter>
    </Box>
  ) : (
    <Progress />
  );
};
